const staffGetAttributes = [
  'classId',
  'course',
  'lesson',
  'startDatetime',
  'studentCount',
  'absenteeCount',
  'rollMarked',
  'notes',
  'location',
  'room',
  'duration',
  'makeUpCount',
  'onlineCount',
  'teacher',
  'enrolledStudents',
  'billingType',
  'homeworkMarked',
  'separatelyBilled',
  'stream',
  'quiz',
] as const;

const staffListAttributes = [...staffGetAttributes] as const;

const studentListAttributes = [
  'classId',
  'course',
  'lesson',
  'startDatetime',
  'studentCount',
  'rollMarked',
  'location',
  'room',
  'duration',
  'teacher',
  // Needed so the student-facing reschedule UI can keep a makeup within the same billing
  // identity as the lesson being replaced (a separately-billed lesson must not be made up
  // into a non-separately-billed one, or vice versa).
  'separatelyBilled',
  'stream',
] as const;

const timesheetAttributes = ['classId', 'lesson', 'startDatetime', 'teacher'] as const;

const teacherUpdateAttributes = ['startDatetime', 'notes', 'homeworkMarked'] as const;

const adminUpdateAttributes = [
  'startDatetime',
  'notes',
  'location',
  'room',
  'billingType',
  'duration',
  'teacher',
  'homeworkMarked',
] as const;

export const LessonAttributes = {
  StaffGet: staffGetAttributes,
  StaffList: staffListAttributes,
  StudentList: studentListAttributes,
  Timesheet: timesheetAttributes,
  TeacherUpdate: teacherUpdateAttributes,
  AdminUpdate: adminUpdateAttributes,
};
